
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { UserNav } from "@/components/user-nav"
import { useGym } from "@/contexts/gym-context"
import { useView } from "@/contexts/view-context"
import { useMobile } from "@/contexts/mobile-context"
import { useUser } from "@/contexts/user-context"
import { UserSearch } from "@/components/header/user-search"
import { SoundToggle } from "@/components/sound-toggle"
import { Menu } from "lucide-react"

interface HeaderProps {
  showSidebarToggle?: boolean
}

export function Header({ showSidebarToggle = true }: HeaderProps) {
  const { t } = useTranslation()
  const { viewMode, hasUnreadNotifications } = useView()
  const { isMobile, toggleSidebar } = useMobile()

  const handleToggleSidebar = () => {
    console.log("Header: Toggle sidebar clicked")
    toggleSidebar()
  }

  return (
    <header className="sticky top-0 z-10 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center px-4">
        {" "}
        {/* Changed height from h-16 to h-14 to match sidebar logo height */}
        <div className="flex-1 flex items-center gap-2">
          {/* Sidebar toggle button for mobile - show for all view modes */}
          {showSidebarToggle && isMobile && (
            <Button
              variant="ghost"
              size="icon"
              onClick={handleToggleSidebar}
              className="mr-2"
              aria-label="Toggle sidebar"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}

          {viewMode === "user" && <div className="text-lg font-semibold">{t("userView.title")}</div>}

          {viewMode === "trainer" && <div className="text-lg font-semibold">{t("trainerView.title")}</div>}

          {viewMode === "reception" && <div className="text-lg font-semibold">{t("receptionView.title")}</div>}
        </div>
        <div className="flex items-center space-x-4">
          {(viewMode === "admin" || viewMode === "reception") && (
            <UserSearch onUserSelect={(user) => console.log("User selected:", user)} />
          )}
          <SoundToggle />
          <UserNav />
        </div>
      </div>
    </header>
  )
}
